<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div v-show="Isblur" class="splash"></div>

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 12vw;"> پست های سازمانی</h2>

              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس پست سازمانی...">

              </div>
              <hr>
            </div>
            <div class="table-responsive mt-3">
              <div @click="addModalMethod" v-show="!all_items.length">
                اولین پست سازمانی خود را ایجاد کنید
              </div>
              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

              <table class="table table-striped" v-show="all_items.length">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  <th style="width: 7vw;">نام کاربری</th>
                  <th>پست سازمانی</th>
                  <th>متصدی</th>
                  <th>جانشین</th>
                  <th style="width: 8vw;">شناسنامه پست</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])" >
                  <td scope="row">{{ index + 1 }}</td>
                  <td>{{ item['id'] }}</td>
                  <td @click="showInfo(item['count'], item['o_name'], item['curator'], item['substitute'] )"
                      style="text-align: right">{{ item['name'] }}
                  </td>
                  <td>
                    <div v-if="item['curator']!=='--' " @click.prevent="addCurator(item.id,item.type,item.substitute_id)" >{{ item['curator'] }}</div>
                    <div v-else>
                      <img style="margin-right: .4vw;"
                           class="table-edit-img"
                           src="../../assets/img/pen.svg"
                           @click.prevent="addCurator(item.id,item.name,item.substitute_id)"
                           alt="edit" title="افزودن">
                    </div>
                  </td>
                  <td>
                    <div v-if="item['substitute']!=='--'"  @click.prevent="addSubstitute(item.id, item.curator_id)">{{ item['substitute'] }}</div>
                    <div v-else>
                      <img style="margin-right: .4vw;"
                           class="table-edit-img"
                           src="../../assets/img/pen.svg"
                           @click.prevent="addSubstitute(item.id,item.curator_id)"
                           alt="edit" title="افزودن">
                    </div>
                  </td>

                  <td>
                    <router-link :to="`/job-description/${item.id}/1`">
                      <img title="شناسنامه پست سازمانی" style="margin-right: .4vw;" class="table-operations-img"
                           src="../../assets/img/id.svg" alt="id">
                    </router-link>


<!--                      <a @click.prevent="editModalMethod(item['id'])" href="#" v-if="item['name']!=='مدیر'">
                        <img style="margin-right: .4vw;"
                             class="table-edit-img"
                             src="../../assets/img/pen.svg"
                             alt="edit"></a>-->

                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Jobs -->

  <div v-show="addModal" dir="rtl" class="col-lg-12 modal__for_fn_two"
       style="position:absolute;  display:block; width: 40vw; right: 45%; top: 45%; transform: translateX(30%) translateY(-45%);   ">
    <div class="card card-body card-panel-box border-0" style="background-color: unset;">
      <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
      <form class="needs-validation" novalidate>

        <div class="row">

          <div class="col-lg-6 mb-3">
            <label class="form-label">پست سازمانی </label>
            <input v-model="name" class="form-control" type="text" name="" required>
            <span style="transform: translateY(-1.3vw) translateX(-16vw); width: 1vw;display: block; cursor: pointer; font-size: 0.5vw" @click="name=''">❌</span>

          </div>
          <div class="col-lg-6 mb-3">
            <label class="form-label">مافوق</label>
            <input v-model="parentName" @click="select_parentModal" class="form-control" type="text" name="" readonly
                   placeholder="انتخاب کنید">
            <span style="transform: translateY(-1.3vw) translateX(-16vw); width: 1vw;display: block; cursor: pointer; font-size: 0.5vw" @click="resetCurator3">❌</span>

          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 mb-3">
            <label class="form-label"> متصدی </label>
            <input v-model="curatorName" @click="select_curatorModal" class="form-control" type="text" name="" readonly
                   placeholder="انتخاب کنید">
            <span style="transform: translateY(-1.3vw) translateX(-16vw); width: 1vw;display: block; cursor: pointer; font-size: 0.5vw" @click="resetCurator">❌</span>


          </div>
          <div class="col-lg-6 mb-3">
            <label class="form-label"> جانشین </label>
            <input v-model="substituteName" @click="select_substituteModal" class="form-control" type="text" name=""
                   readonly
                   placeholder="انتخاب کنید">
            <span style="transform: translateY(-1.3vw) translateX(-16vw); width: 1vw;display: block; cursor: pointer; font-size: 0.5vw" @click="resetCurator2">❌</span>

          </div>
        </div>


        <div class="form-buttons row d-flex justify-content-center">
          <button class="btn btn-primary btn-back mx-3" @click.prevent="addModalMethod">بازگشت</button>
          <button class="btn btn-primary btn-approve" @click.prevent="submitForm">تایید</button>
        </div>

      </form>
    </div>
  </div>
  <!--  modals-->
  <div v-show="editModal" dir="rtl" class="col-lg-12 modal__for_fn_two"
       style="position:absolute;  display:block; width: 40vw; right: 45%; top: 45%; transform: translateX(30%) translateY(-45%);   ">
    <div class="card card-body card-panel-box border-0" style="background-color: unset;">
      <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
      <form class="needs-validation" novalidate>

        <div class="row">

          <div class="col-lg-6 mb-3">
            <label class="form-label">پست سازمانی </label>
            <input v-model="name" class="form-control" type="text" name="" required>
          </div>
          <div class="col-lg-6 mb-3">
            <label class="form-label">مافوق</label>
            <input v-model="parentName" @click="select_parentModal" class="form-control" type="text" name="" readonly
                   placeholder="انتخاب کنید">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 mb-3">
            <label class="form-label"> متصدی </label>
            <input v-model="curatorName" @click="select_curatorModal" class="form-control" type="text" name="" readonly
                   placeholder="انتخاب کنید">

          </div>
          <div class="col-lg-6 mb-3">
            <label class="form-label"> جانشین </label>
            <input v-model="substituteName" @click="select_substituteModal" class="form-control" type="text" name=""
                   readonly
                   placeholder="انتخاب کنید">

          </div>
        </div>


        <div class="form-buttons row d-flex justify-content-center">
          <button class="btn btn-primary btn-back mx-3" @click="backModalMethodEdit">بازگشت</button>
          <button class="btn btn-primary btn-approve" @click="update(id)">تایید</button>
        </div>

      </form>
    </div>
  </div>
  <!--  modals-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_parent" style="z-index: 999999999999999">
    <div>
      <p>انتخاب مافوق</p>
      <p @click="select_parent=!select_parent">❌</p>
    </div>
    <div>
      <input v-model="search_parent" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس پست سازمانی...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>پست سازمانی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredParents" :key="item.id">
          <td scope="row"><input v-model="parentId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_parentMethod">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_curator" style="z-index: 999999999999999">
    <div>
      <p>انتخاب متصدی</p>
      <p @click="select_curator=!select_curator">❌</p>
    </div>
    <div>
      <input v-model="search_curator" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس نام کاربری و نام و نام خانوادگی  ...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کدپرسنلی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in filteredCurator" :key="item.id">
        <tr>
          <td scope="row"><input :id="`item1_${item.id}`" v-model="curatorId" type="radio" name="Curator" :value="item['id']"></td>
          <td><label :for="`item1_${item.id}`">
            {{ item['personal_code'] }}
          </label></td>
          <td>
            <label :for="`item1_${item.id}`">{{ item['fullname'] }}</label></td>
        </tr>

        </tbody>
      </table>
      </div>
      <div class="d-flex">
        <button class="btn btn-submit-1 btn-primary mx-2" @click="select_curatorMethod">تایید</button>
        <button class="btn btn-danger btn-add-org-post d-flex align-items-center justify-content-center"
                style="height: 1.5vw; font-size: 0.8vw;" @click="removeCurator">حذف متصدی</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_substitute" style="z-index: 999999999999999">
    <div>
      <p>انتخاب جانشین</p>
      <p @click="select_substitute=!select_substitute">❌</p>
    </div>
    <div>
      <input v-model="search_curator" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس نام کاربری و نام و نام خانوادگی  ...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>کدپرسنلی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredCurator" :key="item.id">
          <td scope="row"><input :id="`item2_${item.id}`" v-model="substituteId" type="radio" name="substitute" :value="item['id']"></td>
          <td><label :for="`item2_${item.id}`">{{ item['personal_code'] }}</label></td>
          <td><label :for="`item2_${item.id}`">{{ item['fullname'] }}</label></td>
        </tr>

        </tbody>
      </table>
      </div>
      <div class="d-flex">
      <button class="btn btn-submit-1 btn-primary mx-2" @click="select_substituteMethod()">تایید</button>
        <button  class="btn btn-danger btn-add-org-post d-flex align-items-center justify-content-center"
                style="height: 1.5vw; font-size: 0.8vw;" @click="removeSubstitute">حذف جانشین</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="infoModal" style="z-index: 999999999999999">
    <div>
      <p>جزئیات</p>
      <p @click="infoModal=!infoModal">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; border-radius: 1vw; width: 28vw; padding: 1vw;">
        <div class="d-flex justify-content-evenly">
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">پست : {{ name }}</p>
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">متصدی : {{ curator }}</p>
        </div>
        <div class="d-flex justify-content-evenly">
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">جانشین : {{ substitute }}</p>
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">تعداد زیرمجموعه: {{ count }}</p>
        </div>
      </div>

      <button @click="infoModal=!infoModal">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  /modals-->


</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: "ListOrganization",
  components: {Sidebar, Splash},
  data() {
    return {
      id: '',
      name: '',
      addModal: false,
      Isblur: false,
      deleteModal: false,
      select_parent: false,
      select_curator: false,
      select_substitute: false,
      id_remove: '',
      editModal: false,
      infoModal: false,
      Error: false,
      ErrorM: '',
      searchUser: '',
      // users
      all_substitute: [],
      all_curator: [],
      all_parent: [],
      search_parent: '',
      search_curator: '',
      search_substitute: '',
      substituteId: '',
      substituteName: '',
      curatorId: '',
      curatorName: '',
      parentName: '',
      parentId: '',
      all_items: [],
      count: 0,
      curator: '',
      id_item: '',
      substitute: '',
    }
  },
  methods: {
    addCurator(id,name,substitute_id){
      if (name==='تایید کننده') return false;
      this.select_curator = true
      this.id_item = id
      this.id_remove = id
      this.select_curatorModal(substitute_id)


    },
    addSubstitute(id, curator_id){
      this.select_substitute = true
      this.id_item = id
      this.id_remove = id
      this.select_substituteModal(curator_id)


    },
    resetCurator3(){
      this.parentName=''
      this.parentId=''
    },   resetCurator2(){
      this.substituteName=''
      this.substituteId=''
    },
    resetCurator(){
      this.curatorId=''
      this.curatorName=''
    },
    backModalMethodEdit() {
      this.editModal = !this.editModal
      this.Isblur = !this.Isblur
    },
    addModalMethod() {
      this.resetForm()
      this.addModal = !this.addModal
      this.Isblur = !this.Isblur
    },
    showInfo(count, title, curator, substitute) {
      this.infoModal = true
      this.count = count
      this.name = title
      this.curator = curator
      this.substitute = substitute

    },
    nextTree(id, newId) {
      if (newId) {

        fetch(`${this.base_url}/organization/post/change_tree/${id}/to/${newId}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
        })
            .then(response => response.json())
            .then((response) => {
              console.log(response)
              this.all_items.length = 0
              this.fetchAll()
            }).catch((err) => {
          console.log(err)
        })
      }


    },
    previousTree(id, newId) {
      if (newId) {
        if (id > newId) {

          fetch(`${this.base_url}/organization/post/change_tree/${newId}/to/${id}`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${this.$cookies.get('token')}`,
              'Content-type': 'application/json; charset=UTF-8',
            },
          })
              .then(response => response.json())
              .then((response) => {
                this.all_items.length = 0
                this.fetchAll()
              }).catch((err) => {
          })
        } else {
          fetch(`${this.base_url}/organization/post/change_tree/${id}/to/${newId}`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${this.$cookies.get('token')}`,
              'Content-type': 'application/json; charset=UTF-8',
            },
          })
              .then(response => response.json())
              .then((response) => {
                this.all_items.length = 0
                this.fetchAll()
              }).catch((err) => {
          })
        }
      }
    },
    editModalMethod(id) {
      this.id = id
      this.editModal = true
      this.Isblur = !this.Isblur
      this.substituteId = ''
      this.curatorId = ''
      this.parentId = ''


      fetch(`${this.base_url}/organization/post/edit/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
          .then(response => response.json())
          .then((response) =>  {
            this.curatorId = response['curator_item']['id']
            this.substituteName = response['substitute_item']['fullname']
            this.substituteId = response['substitute_item']['id']
            this.parentName = response['parent_item']['name']
            this.parentId = response['parent_item']['id']
            this.name = response['item']['name']
            this.curatorName = response['curator_item']['fullname']
          }).catch((err) => {
      })

    },
    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
            }
            this.deleteModal = false
            this.all_items.length = 0
            this.fetchAll()

          })
          .catch();
    },
    setcolor(level) {

      if (level === 0) {
        return `background: #86D1FF !important`

      }


      if (level === 1) {
        return 'background: #bce6ff !important'

      }
      if (level === 2) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },
    submitForm() {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        } else if (this.curatorId.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'متصدی   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/organization/post/store`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_id': this.parentId,
            'curator': this.curatorId,
            'substitute': this.substituteId,


          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }

              this.loading = false
              this.Isblur = !this.Isblur
              this.addModal = !this.addModal
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    update(id) {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'عنوان   اجباری است!'
          this.loading = false

          return;
        } else if (this.curatorId.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'متصدی   اجباری است!'
          this.loading = false

          return;
        }


        fetch(`${this.base_url}/organization/post/update/${id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_id': this.parentId,
            'curator': this.curatorId,
            'substitute': this.substituteId,


          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                this.Error = true
                this.ErrorM = response['error']
                this.loading = false
                return
              }

              this.loading = false
              this.Isblur = !this.Isblur
              this.editModal = !this.editModal
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()


            }).catch((err) => {
        })


      }, 1000)
    },
    resetForm() {
      this.name = ''
      this.substituteName = ''
      this.curatorName = ''
      this.parentName = ''
    },
    select_substituteMethod() {
      this.select_substitute = !this.select_substitute
      this.select_curator = !this.select_curator
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      if (this.curatorId){
        formdata.append('curator' ,this.curatorId)

      }
      if (this.substituteId){
        formdata.append('substitute', this.substituteId)
      }



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/update_other/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.substituteId = ''
            this.curatorId = ''
            if (response.error){
              toast.error(response.error)
              return;

            }
            if (response.status){
              toast.success('با موفقیت ویرایش شد!')
              this.fetchAll()
              this.select_curator = false
            }

          })
          .catch();
    },
    select_curatorMethod() {
      this.select_curator = !this.select_curator
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      if (this.curatorId){
      formdata.append('curator' ,this.curatorId)

      }
      if (this.substituteId){
        formdata.append('substitute', this.substituteId)
      }



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/update_other/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.substituteId = ''
            this.curatorId = ''
            if (response.error){
              toast.error(response.error)
              return;

            }
            if (response.status){
              toast.success('با موفقیت ویرایش شد!')

              this.fetchAll()
            }
          })
          .catch();
    },
    select_parentMethod() {
      this.select_parent = !this.select_parent
      this.all_parent.forEach((item) => {
        this.parentId === item.id ? this.parentName = item.name : ''

      })

    },


    select_parentModal() {
      this.fetchParents()
      this.select_parent = true
    },

    removeCurator(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/update_other_c/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return;

            }
            if (response.status){
              toast.success('با موفقیت حذف شد!')

              this.fetchAll()
            }
          })
          .catch();
    },
    removeSubstitute(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/update_other_s/${this.id_item}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return;

            }
            if (response.status){
              toast.success('با موفقیت حذف شد!')

              this.fetchAll()
            }
          })
          .catch();
    },
    select_curatorModal(id) {
      this.id_remove = id
      this.fetchUsers(id)
      this.select_curator = true
      this.search_curator = ''

    },
    select_substituteModal(id) {
      this.id_remove = id

      this.fetchUsers2(id)
      this.select_substitute = true
      this.search_curator = ''

    },
    fetchUsers(id) {
      this.all_curator.length = 0
      this.all_substitute.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                if (parseInt(id)!==item.id){
                  this.all_curator.push(item)
                }



              })

            }

          })
          .catch();
    },
    fetchUsers2(id) {
      this.all_curator.length = 0
      this.all_substitute.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                if (parseInt(id) !== item.id){
                  this.all_curator.push(item)

                }


              })

            }

          })
          .catch();
    },
    fetchParents() {
      this.all_parent.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_parent.push(item)

              })

            }

          })
          .catch();
    },
    fetchAll() {
      this.all_parent.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all_tree`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              this.all_items.length=0
              result['all'].forEach(item => {
                this.all_items.push(item)

              })

            }

          })
          .catch();
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }if (!this.mother_mode){
        router.push('/pishkhan/Organization/list/public')
        return
      }

    }
  },
  mounted() {
    this.fetchAll()
    this.checkIsMother()
  },
  computed: {
    filteredParents() {
      return this.all_parent.filter(item => {
        return (
            item['name']&& item['name'].includes(this.search_parent)
        );
      });
    },
    filteredCurator() {
      return this.all_curator.filter(item => {
        return (

            item['fullname']&& item['fullname'].includes(this.search_curator)
        );
      });
    },
    filteredItems() {
      return this.all_items.filter(item => {
        return (
            item['fullname']&&   item['name'].includes(this.searchUser) || item['id'].toString().includes(this.searchUser)
        );
      });
    },

  },
}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}

</style>